import React from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type Props = {
  children: React.ReactNode;
  hideBorderBottom?: boolean;
  addBottomPadding?: boolean;
};

export const FilterGroupSection = ({ children, hideBorderBottom, addBottomPadding }: Props) => {
  return (
    <section
      css={[
        css`
          padding: ${theme.spacing(1, 2, 0)};
        `,
        addBottomPadding &&
          css`
            padding-bottom: ${theme.spacing(2)};
          `,
        !hideBorderBottom &&
          css`
            border-bottom: 1px solid ${theme.colors.neutral10};
          `,
      ]}
    >
      {children}
    </section>
  );
};
